import { TileLayer } from 'react-leaflet'

export const OPENSTREETMAP_TILE_URL = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png'
export const OPENSTREETMAP_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'

/**
 * The shared base layer for both world maps.
 *
 * The CRM deliberately sends `Referrer-Policy: no-referrer` globally. OpenStreetMap requires a
 * Referer from browser clients, so this one image layer opts in to sending only the site's origin.
 * No path, query string, customer, employee or deal information is included.
 */
export function OpenStreetMapTiles() {
  return (
    <TileLayer
      attribution={OPENSTREETMAP_ATTRIBUTION}
      referrerPolicy="strict-origin-when-cross-origin"
      url={OPENSTREETMAP_TILE_URL}
    />
  )
}
